import FooterListItem from "./FooterListItem"
import React from "react"

const ExternalLink = (content, icon, lang) => {
    const { id, externalLink } = content
    return (
        <a key={id} style={{ textDecoration: "none", color: "#000" }} href={`${externalLink}`}>
            {FooterListItem(content, icon, lang)}
        </a>
    )
}

export default ExternalLink
